<template>
    <div>

        <transition :name="modal_transition_name">
            <router-view></router-view>
        </transition>

        <div class="booking">

            <div class="search-container" :class="view">
                <booking-clinic-filters
                    :durations="durationsToShow"
                    :product-areas="productAreas"
                    :preselected-product-area="preselectedProductArea"
                    :loading="poster.submitted"
                    :showDurationFilter="showDurationFilter"
                    :showProductAreaFilter="showProductAreaFilter"
                    @search="search"
                    v-if="all_clinics.length > 0"
                />
            </div>

            <div class="booking-navigation">
                <div class="booking-navigation-btn" :class="{ 'active' : view === 'map' }" @click="changeView('map')">Karta</div>
                <div class="booking-navigation-btn" :class="{ 'active' : view === 'list' }" style="left:74px;" @click="changeView('list')">Lista</div>
                <div class="booking-navigation-marker" :class="{ 'list' : view === 'list' }"></div>
            </div>

            <div class="view map" :class="{ 'active' : view === 'map', 'has-filters' : showDurationFilter }">
                <bookingClinicMap
                    :clinics="filteredClinics"
                    :showDurationFilter="showDurationFilter"
                    :hasActiveSearch="filters.text !== ''"
                    :filters="filters"
                    :loading="poster.submitted"
                    v-if="all_clinics.length > 0"
                />
            </div>

            <div class="view list" :class="{ 'active' : view === 'list', 'has-filters' : showDurationFilter }">
                <booking-clinic-list :clinics="clinics" :hasActiveSearch="hasActiveSearch" :filters="filters" :loading="poster.submitted" />
            </div>

        </div>

    </div>
</template>

<script>
import poster from '../../../shared/mixins/poster'
import fetcher from '../../../shared/mixins/fetcher'

import bookingClinicFilters from './booking-clinic-filters'
import bookingClinicMap from './booking-clinic-map'
import bookingClinicList from './booking-clinic-list'

export default {

    name: 'booking-clinic',

    mixins: [
        poster,
        fetcher
    ],

    components: {
        bookingClinicFilters,
        bookingClinicMap,
        bookingClinicList
    },

    data () {
        return {

            modal_clinic_id: null,
            modal_transition_name: 'modal',

            durations: [],
            productAreas: [],
            preselectedProductArea: null,
            all_clinics: [], // Innehåller alla clinics med mottagning för kundens tillgängliga durations
            fetcher: {
                autoFill: [
                    'durations',
                    'productAreas',
                    'preselectedProductArea',
                    'all_clinics'
                ]
            },

            filters: {
                text: '',
                duration: null,
                product_area: null
            },

            clinics: [], // Innehåller de clinics som användaren aktivt sökt fram

            loading: false,
            view: 'map',

            searchHistory: []
        }
    },

    computed: {
        fetcherUrl () {
            return '/booking'
        },
        posterUrl () {
            return '/booking/search'
        },
        posterData () {
            return this.filters
        },
        durationsToShow () {
            return this.durations.filter(d => d !== 60)
        },
        showDurationFilter () {
            return this.app_version === 'customer_card' && this.durationsToShow.length > 1 && (this.filters.product_area === 1 || (this.productAreas.length === 1 && this.productAreas[0] === 1))
        },
        showProductAreaFilter () {
            return this.app_version === 'customer_card' && this.productAreas.length > 1
        },
        hasActiveSearch () {
            return this.filters.text !== '' || this.filters.duration !== null || (this.productAreas.length > 1 && this.filters.product_area !== null)
        },
        filteredClinics () {
            if (!this.hasActiveSearch) {
                return this.all_clinics
            }
            // if (this.clinics.length === 0 && Object.keys(this.params).length === 0) {
            //     return this.addresses
            // }

            const clinic_ids = this.clinics.map(c => c.id)

            return this.all_clinics.filter(a => clinic_ids.indexOf(a.id) !== -1)
        }
    },

    methods: {

        search (filters) {
            this.filters.text = filters.text
            this.filters.duration = filters.duration
            this.filters.product_area = filters.product_area

            if (!this.hasActiveSearch) {
                this.clinics = []
                return
            }

            this.posterPost()
            document.activeElement.blur()
        },

        posterSuccess (data) {
            this.clinics = data.clinics
        },

        changeView (view) {
            this.view = view

            if (this.view === 'map') {
                this.matomoTrackEvent('Booking', 'Navigation', 'Map')
            }

            if (this.view === 'list') {
                this.matomoTrackEvent('Booking', 'Navigation', 'List')
            }
        }

    }

    // watch: {
    // '$route' (to, from) {
    //     console.log('from ' + from.name)
    //     console.log('to ' + to.name)

    //     if (from.name === 'modal-address' && to.name === 'modal-clinic') {
    //         this.modal_transition_name = 'fademodal'
    //     } else if (from.name === 'modal-address' && to.name === 'modal-clinic') {
    //         this.modal_transition_name = 'fademodal'
    //     } else {
    //         this.modal_transition_name = 'modal'
    //     }

    //     console.log('modal_transition_name ' + this.modal_transition_name)
    // }
    // },
}
</script>
<style type="text/css">
/* --- Transition modal --- */
.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 400ms ease-out;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, 100%);
}

</style>
